import React from 'react';
import styled, { css } from 'styled-components';
import { Box, Text } from '@sparknz/spark-pattern-library';

import { useWearableDevice } from 'journey/productDetails/components/ProductConfigurator/hooks';
import { useProductDetails } from 'journey/productDetails/provider';
import { ImageWithFallback } from 'shared/components';

const StyledImageWithFallback = styled(ImageWithFallback)`
  ${({ theme: { spacing } }) => css`
    height: 72px;
    width: 72px;
    margin-right: ${spacing.s3};
    object-fit: cover;
  `}
`;

const EligibilityLineSelectorProductDetails = () => {
  const {
    selectedDevice: { name, images },
    selectedColor,
  } = useProductDetails();

  const { isWearable } = useWearableDevice();

  const deviceImageUrl = images ? images[0]?.defaultUrl : null;

  const choosePlanDescription = isWearable
    ? `Select the plan that you want to connect to your new watch. Not all plans are eligible.`
    : `Select an eligible plan or a new Spark plan below. Please note that not
        all plans are eligible for interest free payments.`;
  return (
    <>
      <Text variant="subheadingM" mb="s6">
        Your product
      </Text>

      <Box flexDirection="row" mb="s6">
        <StyledImageWithFallback
          src={deviceImageUrl}
          alt="The selected device."
        />
        <div>
          <Text variant="bodySDemi">{name}</Text>
          <Text variant="bodySMedium">{selectedColor}</Text>
          {/* replace with actual quantity, currently quantity can only be 1 */}
          <Text variant="bodySMedium">Quantity: 1</Text>
        </div>
      </Box>

      <Text variant="subheadingM" mb="s1">
        Choose a plan
      </Text>
      <Text variant="bodySMedium" mb="s4">
        {choosePlanDescription}
      </Text>
    </>
  );
};

export default EligibilityLineSelectorProductDetails;
